<template>
  <div>
    <el-row v-for="(chart, index) in $root.unusedChartChatList" :key="index">
      <div @click="OnRemove(chart.name)">
        <el-card shadow="always">
          {{ chart.displayName }}
        </el-card>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "RealTimeChatSettingMenu",
  methods: {
    OnRemove(title) {
      let list = this.$root.unusedChartChatList;
      for (let index in list) {
        if (list[index].name === title) {
          this.$root.usedChartChatList.push(
            this.$root.unusedChartChatList[index]
          );
          this.$root.unusedChartChatList.splice(index, 1);
        }
      }
      localStorage.setItem('usedChartChatList', JSON.stringify(this.$root.usedChartChatList))
      if (this.$root.usedChartChatList.length <= 5) {
        this.$root.barscrollFlg = "false";
      } else {
        this.$root.barscrollFlg = "true";
      }
    },
  },
};
</script>


<style>
</style>
